import React, { useState } from 'react'
import Button from '../../components/shared/buttons/button'
import Datatable from '../../components/shared/datatable/Datatable'
import { useNavigate } from 'react-router'
import { useGetAllSurveysQuery } from '../../app/surveyApi/surveyApi'
import { formatDateToMDY } from '../../helpers/Utils'
import { AiOutlineEye } from "react-icons/ai";
import DeleteSurveyModal from '../../components/shared/modalContent/DeleteSurveyModal'
import { MdOutlineEditNote,MdDeleteOutline } from "react-icons/md";
import { useParams } from 'react-router'
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb'
const Survey = () => {
    const {id} = useParams()
    console.log(id,"id->");
    
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("")
    const [showDeleteSurveyModal, setShowDeleteSurveyModal] = useState(false)
    const [selectedSurveyId, setSelectedSurveyId] = useState(null);

    const { data: surveyList, isLoading } = useGetAllSurveysQuery({ page, limit: 10, search,id });
    const onPageChange = (newPage) => {
        setPage(newPage);
    }
    const handleFilterSearch = (value) => {
        setSearch(value);
        setPage(1); // Optional: reset to first page on new search
    };
    const navigate = useNavigate()

    const columns = [
        { label: "Survey title", accessor: "title" },
        {
            label: "Survey created at", accessor: "createdAt",
            cell: ({ row }) => (
                <>{formatDateToMDY(row?.createdAt)}</>
            )
        },
        {
            label: "Survery updated", date: "updatedAt",
            cell: ({ row }) => (
                <>{formatDateToMDY(row?.updatedAt)}</>
            )
        },
        {
            label: "View", accessor: "Action",
            cell: ({ row }) => (

                <div className='d-flex gap-2 align-items-center'>
                    <Button className={'borderedBtn'} size={'xs'} onClick={() => navigate(`/survey-category/survey/survey-details/${row?._id}`,{ state: { surveyId: row?._id,cateId : id } })} icon={<AiOutlineEye size={24} />
                    } />
                    <Button className={'borderedBtn'} size={'xs'} onClick={() => navigate(`/survey-category/survey/edit-survey`, { state: { surveyId: row?._id ,cateId : id, } })} icon={<MdOutlineEditNote size={24} />
                    } />
                    <Button
                        className={'borderedBtn'}
                        size={'xs'}
                        onClick={() => {
                            setSelectedSurveyId(row?._id);
                            setShowDeleteSurveyModal(true);
                        }}
                        icon={<MdDeleteOutline size={24} />} // Replace with delete icon like <MdDelete />
                    />

                </div>
            ),
        },


    ];
  const breadcrumbItems = [
    { label: 'Survey Category', path: '/survey-category' },
    { label: `Survey `}
  ];
    return (
        <div>
            <DeleteSurveyModal show={showDeleteSurveyModal} setShow={setShowDeleteSurveyModal}  surveyId={selectedSurveyId} />
            <CommonBreadcrumb  items={breadcrumbItems}/>
            <Datatable
                isLoading={isLoading}
                tableData={surveyList?.data}
                columns={columns}
                page={page}
                onPageChange={onPageChange}
                showPegination={true}
                showFilter={true}
                title={'Surveys'}
                buttonTitle="Create Survey"
                onFilterSearch={handleFilterSearch}
                onClick={() => { navigate('/survey-category/survey/create-survey',{ state: { surveyId: id,cateName : surveyList?.data?.category_name} }) }}

            />
        </div>
    )
}

export default Survey